import * as _ from 'lodash';
import * as moment from 'moment';
import { Pipe, PipeTransform } from '@angular/core';
import { formats as formatsCatalog, charts as chartsCatalog } from 'src/app/utils/catalog';
import { Action, ActionType } from '../components/pages/landing-page/landing-page.component';

@Pipe({
  name: 'actionDateRange',
})
export class ActionDateRangePipe implements PipeTransform {
  transform(action: Action, ...args: unknown[]): string {
    switch (_.get(action, 'data.type', null)) {
      case chartsCatalog.scales.day:
        return moment(_.get(action, 'data.from')).format(formatsCatalog.date.moment);
      case chartsCatalog.scales.week:
        return `${moment(_.get(action, 'data.from')).format(formatsCatalog.date.moment)} - ${moment(_.get(action, 'data.to')).format(formatsCatalog.date.moment)}`;
      case chartsCatalog.scales.month:
        return moment(_.get(action, 'data.from')).format(formatsCatalog.month.momentLong);
      case chartsCatalog.scales.year:
        return moment(_.get(action, 'data.from')).format(formatsCatalog.year.momentLong);
      default:
        return '';
    }
  }
}
